import {
  faArrowRightArrowLeft,
  faBoxOpen,
  faFileContract,
  faGear,
  faHouse,
  faServer,
  faSliders,
  faTags,
  faUsers,
} from '@fortawesome/pro-regular-svg-icons';

import { MenuConfig } from '@/types/menu.types';

export const menuConfig: MenuConfig = {
  items: [
    {
      id: 'home',
      icon: faHouse,
      label: 'Accueil',
      translationKey: 'header.menu.home',
      path: '/',
      showInMenu: true,
    },
    {
      id: 'pixid-contracts',
      icon: faFileContract,
      label: 'Contrats',
      translationKey: 'header.menu.pixid_contracts_dashboard',
      path: '/contrats',
      showInMenu: true,
      conditions: {
        isAuthenticated: true,
      },
    },
    {
      id: 'pixid-orders',
      icon: faBoxOpen,
      label: 'Commandes',
      translationKey: 'header.menu.pixid_orders_dashboard',
      path: '/commandes',
      showInMenu: true,
      conditions: {
        isAuthenticated: true,
      },
    },
    {
      id: 'pixid-resources',
      icon: faUsers,
      label: 'Intérimaires',
      translationKey: 'header.menu.pixid_resources_dashboard',
      path: '/interimaires',
      showInMenu: true,
      conditions: {
        isAuthenticated: true,
      },
    },
    {
      id: 'pixid',
      icon: faSliders,
      label: 'Plateforme Pixid',
      translationKey: 'header.menu.pixid',
      showInMenu: true,
      conditions: {
        isAuthenticated: true,
      },
      children: [
        {
          id: 'pixid-param-demat',
          icon: faSliders,
          label: 'Paramètres Démat',
          translationKey: 'header.menu.pixid_dashboard',
          path: '/pixid/param-demat',
          showInMenu: true,
          conditions: {
            isAuthenticated: true,
          },
        },
      ],
    },
    {
      id: 'config',
      icon: faGear,
      label: 'Configuration',
      translationKey: 'header.menu.config',
      showInMenu: true,
      conditions: {
        isAuthenticated: true,
      },
      children: [
        {
          id: 'rubriques-clients',
          icon: faTags,
          label: 'Rubriques clients',
          translationKey: 'header.menu.config.heading_clients',
          path: '/config/rubriques-clients',
          showInMenu: true,
          conditions: {
            isAuthenticated: true,
          },
        },
        {
          id: 'document-mapping',
          icon: faArrowRightArrowLeft,
          label: 'Mapping des documents',
          translationKey: 'header.menu.config.document_mapping',
          path: '/config/document-mapping',
          showInMenu: true,
          conditions: {
            isAuthenticated: true,
          },
        },
        {
          id: 'client-vms-config',
          icon: faServer,
          label: 'Configuration Client VMS',
          translationKey: 'header.menu.config.client_vms_config',
          path: '/config/client-vms-config',
          showInMenu: true,
          conditions: {
            isAuthenticated: true,
          },
        },
      ],
    },
  ],
};
